import { IconButton, InputAdornment, TextField } from '@mui/material'
import { forwardRef, ForwardedRef, useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { EFInputLabel } from '../EFInputLabel'
import { EFTextFieldProps } from './EFTextField.model'
import classNames from 'classnames/bind'
import styles from './EFTextField.module.scss'
import { getNestedError } from '~/utils/objectHelper'
import { omit } from '~/utils/commonServices'

const cx = classNames.bind(styles)

export const EFPasswordField = forwardRef(
  (props: EFTextFieldProps, _ref: ForwardedRef<unknown>) => {
    const { control, setValue, formState } = useFormContext()
    const theme = useAppSelector(currentTheme)

    const [showPassword, setShowPassword] = useState(false)
    const handleClickShowPassword = () => setShowPassword(!showPassword)

    const safeProps = omit(props, ['validateFn']);
    return (
      <Controller
        control={control}
        name={props.name}
        rules={{ validate: props.validateFn }}
        render={({ field, fieldState }) => (
          <div className='custom-field'>
            {props.label && (
              <EFInputLabel
                label={props.label}
                name={props.name}
                sx={props.labelSx}
              />
            )}
            <TextField
              {...safeProps}
              {...field}
              sx={{
                ...props.sx
              }}
              type={showPassword ? 'text' : 'password'}
              autoComplete={props.autocompletehint ?? 'new-password'}
              name={field.name}
              value={field.value || ''}
              placeholder={props.placeholder}
              id={field.name}
              InputLabelProps={{ sx: { display: 'none' }, shrink: false }}
              className={cx('text-field', theme)}
              FormHelperTextProps={{
                sx: { marginX: 0, color: 'red !important' }
              }}
              onChange={(e: any) => {
                setValue(field.name, e.target.value, { shouldValidate: true, shouldDirty:true })
                props.onChange?.(e)
              }}
              error={fieldState.invalid === true}
              helperText={fieldState.invalid === true ? getNestedError(formState, `errors.${field.name}.message`) : undefined}

              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      disableRipple
                      aria-label='toggle password visibility'
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? (
                        <Visibility sx={{ '& path': { color: '#E0E0E0 !important' } }} />
                      ) : (
                        <VisibilityOff
                          sx={{ '& path': { color: '#E0E0E0 !important' } }}
                        />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </div>
        )}
      />
    )
  }
)
